import React from 'react';
import cn from 'classnames';

import { SigininWrapper } from '../SigninWrapper';
import { Advertisement } from '../Advertisement';
import { FormWrapper } from '../FormWrapper';
import { IProps } from './types';

import { useSelector } from 'react-redux';
import { IApplicationState } from '@app/store/types/commonTypes';
import { COPYRIGHT, COPYRIGHT_METROFILE, Instance, InstanceVar } from '@app/const/consts';

import styles from './styles.module.scss';
import { getInstanceVar } from '@app/utils/utils';

export const SigninContainer = (props: IProps) => {
  const instance = useSelector((state: IApplicationState) => state.utils.instance);
  const { refContainer, children, isMobile, horizontalView, ...others } = props;

  const copyRightNotRu = getInstanceVar() === InstanceVar.METROFILE ? COPYRIGHT_METROFILE : COPYRIGHT;
  const copyright = (instance !== Instance.RUSSIAN ? copyRightNotRu : 'InfoLogistics LLC') + '. All rights reserved.';

  return (
    <div
      ref={refContainer}
      className={cn(
        styles.container,
        { [styles.container_mobile]: isMobile || horizontalView },
        'd-flex align-items-center justify-content-center',
      )}
    >
      {!isMobile && (
        <SigininWrapper className={cn(styles.advertisement)} advertisement horizontalView={horizontalView}>
          <Advertisement copyright={copyright} horizontalView={horizontalView} />
        </SigininWrapper>
      )}
      <SigininWrapper form isMobile={isMobile} horizontalView={horizontalView}>
        <FormWrapper copyright={copyright} horizontalView={horizontalView} {...others}>
          {children}
        </FormWrapper>
      </SigininWrapper>
    </div>
  );
};
